<template>
  <div class="consultant-earning-summary">
    <div class="earning-history">
      <h3 class="pay-h">Payment History</h3>
      <ul v-if="this.paymt.length > 0">
        <li v-for="p in this.paymt" :key="p.id">
          <span class="hired-by-title">Paid</span>
          <!--              <span class="hired-by">Tk.{{ p.amount }} - {{ p.name }}</span>-->
          <span class="hiring-time">{{ p.time }}</span>
        </li>
      </ul>
      <ul v-else>
        <li>No payment made</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "payHist",
  props: ["paymt"]
};
</script>

<style scoped>
.pay-h{
   text-align: left;
  font-family: 'Open Sans';
  font-size: 32px;
  font-weight: 700;
letter-spacing: -1.6px;
color: #000000;
padding-left: 100px;
padding-top: 50px;

}
.hired-by-title{
   text-align: left;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 700;
letter-spacing: -0.14px;
color:#3800BC !important;

padding-left: 100px;
padding-top: 20px;

}
.hiring-time{
    text-align: left;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 700;
letter-spacing: -0.14px;
color:#728391 !important;

padding-left: 100px;
padding-top: 20px;
padding-bottom: 20px;
}
.earning-history {
  width: 70%;
  margin: 0 auto;
  background-color: #ffffff;
}
.earning-history ul {
  background-color: #ffffff;
}
@media only screen and (max-width: 600px) {
  .earning-history {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
}
.pay-h{
   text-align: center;
  font-family: 'Open Sans';
  font-size: 24px;
  font-weight: 700;
letter-spacing: -1.2px;
color: #000000;
padding-left: 0px;
padding-top: 30px;
margin-bottom: 0;

}
.hired-by-title{
   text-align: left;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 700;
letter-spacing: -0.12px;
color:#3800BC !important;

padding-left: 20px;
padding-top: 20px;

}
.hiring-time{
    text-align: left;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 400;
letter-spacing: 0;
color:#728391 !important;

padding-left: 20px;
padding-top: 10px;
padding-bottom: 20px;
}

.earning-history ul {
  background-color: #ffffff;
}
}

</style>
